import { keyBy, merge, values } from 'lodash';

import { getEntities } from '@swf/core/analytics/utils';
import type { TrackingContextValue } from '@swf/core/providers/TrackingContext';
import type { Entity } from '@swf/generated/analytics/entities';

const mergeWithExistingTrackingEntities = (
  trackingContext: TrackingContextValue,
  entities: Entity[]
): Entity[] => {
  const existingEntities = getEntities(trackingContext);

  return values(merge(keyBy(existingEntities, 'schema'), keyBy(entities, 'schema')));
};

const mergeWithTrackingContextValue = (
  trackingContext: TrackingContextValue,
  entities: Entity[]
): TrackingContextValue => ({
  ...trackingContext,
  entities: mergeWithExistingTrackingEntities(trackingContext, entities)
});

export default mergeWithTrackingContextValue;
